export const EVENTS = {
  // --= Main landing =--
  landingView: 'landing.view',
  landingDownloadRustoreMainClick: 'landing.downloadRustoreMain.click',
  landingScrollDownScroll: 'landing.scrollDown.scroll',
  landingFeatureView: 'landing.featuresBlock.view',
  landingClick: 'landing.click',

  // --= Instruction page =--
  instructionsView: 'instructions.view',
  instructionsRustoreAPKDownload: 'instructions.rustoreAPK.download',
  instructionsDownloadApkRustoreClick: 'download_apk_rustore_click',
  instructionsDownloadApkRustoreClickOrAutomatic:
    'download_apk_rustore_click_or_automatic',
  instructionsLinkToDownloadRuStoreAPKCopy:
    'instructions.linkToDownloadRuStoreAPK.copy', // только web
  instructionsRustoreAPKBottomDownload:
    'instructions.rustoreAPKBottom.download', // только mobile
  instructionsScrollDownScroll: 'instructions.scrollDown.scroll',
  instructionsRustoreAPKDownloadClick: 'instructions.rustoreAPK.download.click',
  instructionsRustoreAPKAutomaticDownload:
    'instructions.rustoreAPK.automaticDownload',
  mtApkLoading: 'mt_apkLoading',
  instructionDeeplinkPopupShown: 'popUp.show',

  // --=TV Instruction =--

  instructionsTVView: 'instructionsTV.view', // Событие открытие страницы тв
  instructionTVAPKDownload: 'instructionsTV.rustoreAPK.download.click', //Событие скачивание АПК ТВ
  linkToDownloadRuStoreTVAPK: 'instructionsTV.linkToDownloadRuStoreAPK.copy', //Событие копирования ссылки на АПК ТВ
  instructionsTVScroll: 'instructionsTV.scrollDown.scroll', //Событие скролла страницы инструкции ТВ

  // --= COMMON =--
  // Header Nav Links
  appsTopClick: 'appsTop.click',
  gamesTopClick: 'gamesTop.click',
  devTopClick: 'devTop.click',
  supportTopClick: 'supportTop.click',
  downloadRustoreTopClick: 'downloadRustoreTop.click',
  // Footer links
  userAgreementBottomClick: 'userAgreementBottom.click',
  confidentialityBottomClick: 'confidentialityBottom.click',
  footerTvClick: 'footer.rustoreForTV.click',
  footerNetworkClick: 'footer.networkClick',
  footerClick: 'footer.click',

  //Search
  searchClick: 'search.click',
  searchBarClick: 'searchBar.click',
  searchBarHistoryShow: 'searchBar.history.show',
  searchBarHistoryClearAll: 'searchBar.history.clearAll',
  searchBarHistoryDelete: 'searchBar.history.delete',
  searchBarSuggestionsShow: 'searchBar.suggestions.show',
  searchBarSuggestionsClick: 'searchBar.suggestions.click',
  searchBarSuggestionsEnter: 'searchBar.suggestions.enter',
  searchQuery: 'searchQuery',
  searchView: 'searchBlock.view',

  //Mini-Picks
  landingRecommendedAppsView: 'landing.recommendedApps.view',
  appSelect: 'app.select',

  //A/B tests omicron
  omicronFromLandingToInstructions: 'omicron.fromLandingToInstructions',
  omicronFromLandingToVitrina: 'omicron.fromLandingToVitrina',

  //Media-kit
  mediaKitHeaderClick: 'mediaKit.header.click',
  mediaKitScrollDownScroll: 'mediaKit.scrollDown.scroll',
  mediaKitView: 'mediaKit.view',
  mediaKidNewsView: 'mediaKid.news.view',
  mediaKitFormStyleClick: 'mediaKit.formStyle.click',
  mediaKitOtherMaterialsClick: 'mediaKit.otherMaterials.click',
  mediaKitNewsClick: 'mediaKit.news.click',
  mediaKitAllNewsClick: 'mediaKit.allNews.click',
  footerMediaKitNetworkClick: 'footer.mediaKit.networkClick',
  footerMediaKitClick: 'footer.mediaKit.click',

  //Offer pages
  partnerLandingDownloadRustore: 'partnerLanding.downloadRustoreMain.click',
  partnerLandingClickApp: 'partnerLanding.appInstallViaRustore.click',
  partnerLandingView: 'partnerLanding.view',
  partnerLandingModalShow: 'partnerLanding.Modal.show',
  partnerLandingDownloadRustoreClick: 'partnerLanding.downloadRustore.click',

  //Articles and games
  compilationCardClick: 'compilationCard.click',
  compilationClick: 'compilation.click',
  compilationSwipeLeftSwipe: 'compilation.SwipeLeft.swipe',
  compilationSwipeRightSwipe: 'compilation.SwipeRight.swipe',
  compilationView: 'compilation.view',
  compilationCardView: 'compilationCard.view',
  scrollDownscroll: 'scrollDown.scroll',
  downloadRuStoreButton: 'downloadRuStoreButton',
  appDownloadClick: 'appDownload.click',
  relatedArticlesClick: 'relatedArticles.click',

  //Header events
  headerLinkClick_apps: 'appsTop.click',
  headerLinkClick_games: 'gamesTop.click',
  headerLinkClick_devs: 'devTop.click',
  headerLinkClick_help: 'supportTop.click',
  headerLinkClick: 'header.click', //Аналогична метрикам выше, но не привязана к названию кнопки

  // breadcrumbs
  breadcrumbsClick: 'appPage.breadCrumbs.click',

  // --= PreloadLaw page =--
  preloadLawView: 'preloadLaw.view',
  preloadLawSendClick: 'preloadLaw.sendRequest.click',
  preloadLawEmailClick: 'preloadLaw.copyEmail.click',

  // --= Aurora page =--

  auroraOSView: 'auroraOS.view',
  auroraOSLearnMoreClick: 'auroraOS.learnMore.click',
  auroraOSDownloadClick: 'auroraOS.rustoreAPK.download.click',
  auroraOSModalDownloadClick:
    'auroraOS.rustoreAPK.download.deviceVersion.click',

  // --= Parental control page =--

  kidModeView: 'kidMode.view',
  kidModeDownloadRustoreMainClick: 'kidMode.downloadRustoreMain.click',

  kidModeTabClick: 'kidMode.tab.click',
  kidModeVideoPlay: 'kidMode.video.play',

  //autoupdate page
  autoupdateView: 'autoUpdateLanding.view',
  downloadClick: 'downloadRuStoreButton',

  // careers page
  careerLandingView: 'careerLanding.view',

  mt_pixel: 'mt_pixel',

  buttonClick: 'button.click',

  //switch language
  headerClick: 'header.click',
  dropdownListClick: 'dropdownList.click',

  prostoreAccordionClick: 'article.contents.click',

  //download hint

  popUpClose: 'popUp.close',
  popUpShow: 'popUp.show',

  //FAQ

  instructionsQAOpen: 'instructions.QA.open',
  instructionsQAClose: 'instructions.QA.close',

  instructionsTvQAOpen: 'instructionsTV.QA.open',
  instructionsTvQAClose: 'instructionsTV.QA.close',

  // Authors
  authorPageView: 'authorPage.view ',
  authorPageScrollDownScroll: 'authorPage.scrollDown.scroll',
  articleClick: 'article.click',
  authorPageClick: 'authorPage.click',

  //Prostore
  prostoreCategoryClick: 'prostoreCategory.click',
  prostoreCategoryView: 'prostoreCategory.view',
  prostoreArticleView: 'prostoreArticle.view',
  articleSwipeRight: 'article.swipeRight',
  articleSwipeLeft: 'article.swipeLeft',

  //Car
  instructionsCarRustoreAPKDownload: 'instructionsCar.rustoreAPK.download',
  instructionsCarRustoreAPKDownloadClick:
    'instructionsCar.rustoreAPK.download.click',
  instructionsCarView: 'instructionsCar.view',
  instructionsCarWayToDownloadSelect: 'instructionsCar.wayToDownload.select',
  instructionsCarQAHyperLinkClick: 'instructionsCar.QA.hyperLink.click',
  instructionsCarQAOpen: 'instructionsCar.QA.open',
  instructionsCarQAClose: 'instructionsCar.QA.close',
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];

export const isValidEventName = (eventName: string): eventName is EventName => {
  return Object.values<string>(EVENTS).includes(eventName);
};
